import {
  CLUSTERS_GET_CLUSTERS_REQUESTED,
  CLUSTERS_GET_CLUSTERS_UPDATED,
  CLUSTERS_GET_MERCHANTS_INVALIDATE,
  CLUSTERS_GET_MERCHANTS_REQUESTED,
  CLUSTERS_GET_MERCHANTS_UPDATED,
  CLUSTERS_GET_MERCHANT_BY_MERCHANT_ID_REQUESTED,
  CLUSTERS_GET_MERCHANT_BY_MERCHANT_ID_UPDATED,
  CLUSTERS_GET_OFFER_BY_OFFER_ID_REQUESTED,
  CLUSTERS_GET_OFFER_BY_OFFER_ID_UPDATED,
  CLUSTERS_GET_REDEEMED_OFFERS_REQUESTED,
  CLUSTERS_GET_REDEEMED_OFFERS_UPDATED,
  CLUSTERS_SEND_OFFER_CODE_REQUESTED,
  CLUSTERS_SEND_OFFER_CODE_RESET,
  CLUSTERS_SEND_OFFER_CODE_UPDATED,
  LOGOUT,
} from '../actionTypes';

const initialState = () => ({
  getClusters: {
    data: [],
    error: null,
    loading: false,
  },
  getMerchants: {
    data: [],
    error: null,
    loading: false,
  },
  getMerchantByMerchantId: {
    data: null,
    error: null,
    loading: false,
  },
  getOfferByOfferId: {
    data: [],
    error: null,
    loading: false,
  },
  sendOfferCode: {
    data: [],
    error: null,
    loading: false,
  },
  getRedeemedOffers: {
    data: [],
    error: null,
    loading: false,
  },
});

export const clustersReducer = (state = initialState(), action) => {
  switch (action.type) {
    case CLUSTERS_GET_CLUSTERS_REQUESTED:
      return {
        ...state,
        getClusters: {
          ...state.getClusters,
          loading: true,
        },
      };
    case CLUSTERS_GET_CLUSTERS_UPDATED:
      return {
        ...state,
        getClusters: {
          data: action.payload.data,
          error: action.payload.error,
          loading: false,
        },
      };
    case CLUSTERS_GET_MERCHANTS_REQUESTED:
      return {
        ...state,
        getMerchants: {
          ...state.getMerchants,
          loading: true,
        },
      };
    case CLUSTERS_GET_MERCHANTS_INVALIDATE:
      return {
        ...state,
        getMerchants: {
          ...initialState().getMerchants,
        },
      };
    case CLUSTERS_GET_MERCHANTS_UPDATED:
      return {
        ...state,
        getMerchants: {
          data: action.payload.data,
          error: action.payload.error,
          loading: false,
        },
      };
    case CLUSTERS_GET_REDEEMED_OFFERS_REQUESTED:
      return {
        ...state,
        getRedeemedOffers: {
          ...state.getRedeemedOffers,
          loading: true,
        },
      };
    case CLUSTERS_GET_REDEEMED_OFFERS_UPDATED:
      return {
        ...state,
        getRedeemedOffers: {
          data: action.payload.data,
          error: action.payload.error,
          loading: false,
        },
      };
    case CLUSTERS_GET_MERCHANT_BY_MERCHANT_ID_REQUESTED:
      return {
        ...state,
        getMerchantByMerchantId: {
          ...state.getMerchantByMerchantId,
          loading: true,
        },
      };
    case CLUSTERS_GET_MERCHANT_BY_MERCHANT_ID_UPDATED:
      return {
        ...state,
        getMerchantByMerchantId: {
          data: action.payload.data,
          error: action.payload.error,
          loading: false,
        },
      };
    case CLUSTERS_GET_OFFER_BY_OFFER_ID_REQUESTED:
      return {
        ...state,
        getOfferByOfferId: {
          ...state.getOfferByOfferId,
          loading: true,
        },
      };
    case CLUSTERS_GET_OFFER_BY_OFFER_ID_UPDATED:
      return {
        ...state,
        getOfferByOfferId: {
          data: action.payload.data,
          error: action.payload.error,
          loading: false,
        },
      };
    case CLUSTERS_SEND_OFFER_CODE_REQUESTED:
      return {
        ...state,
        sendOfferCode: {
          ...state.sendOfferCode,
          loading: true,
        },
      };
    case CLUSTERS_SEND_OFFER_CODE_UPDATED:
      return {
        ...state,
        sendOfferCode: {
          data: action.payload.data,
          error: action.payload.error,
          loading: false,
        },
      };
    case CLUSTERS_SEND_OFFER_CODE_RESET:
      return {
        ...state,
        sendOfferCode: {
          data: [],
          error: null,
          loading: false,
        },
      };
    case LOGOUT:
      return initialState();
    default:
      return state;
  }
};
